export default __webpack_public_path__ + "static/media/Home-foto-header-corporate-Tower-viajes-mobile@3x.82919603.jpg";